/** Ops rail (7 counters + activity feed). */
import type { Dashboard } from "@/entities/mission-control";

interface OpsRailProps {
  dashboard: Dashboard | undefined;
  loading: boolean;
}

const COUNTERS = [
  { key: "scheduled-today",      label: "Scheduled Today",     field: "scheduled_today" as const,          accent: "text-sky-600 dark:text-sky-300" },
  { key: "waiting",              label: "Assets Waiting",      field: "waiting" as const,                  accent: "text-amber-600 dark:text-amber-300" },
  { key: "queue-depth",          label: "Queue Depth",         field: "queue_depth" as const,              accent: "text-indigo-600 dark:text-indigo-300" },
  { key: "campaign-completion",  label: "Campaign Completion", field: "campaign_completion_avg" as const,  accent: "text-emerald-600 dark:text-emerald-300", suffix: "%" },
  { key: "upcoming-deadlines",   label: "Upcoming (24h)",      field: "upcoming_deadlines" as const,       accent: "text-cyan-600 dark:text-cyan-300", isArray: true },
  { key: "publishing-errors",    label: "Publishing Errors",   field: "publishing_errors" as const,        accent: "text-rose-600 dark:text-rose-300" },
  { key: "activity",             label: "Activity (24h)",      field: "workspace_activity_24h" as const,   accent: "text-fuchsia-600 dark:text-fuchsia-300" },
];

export function OpsRail({ dashboard, loading }: OpsRailProps): JSX.Element {
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-7">
      {COUNTERS.map((c) => {
        const raw = dashboard ? (dashboard as unknown as Record<string, unknown>)[c.field] : undefined;
        const value = c.isArray ? (Array.isArray(raw) ? raw.length : 0) : (typeof raw === "number" ? raw : 0);
        return (
          <div
            key={c.key}
            data-testid={`mc-dashboard-${c.key}`}
            className="rounded-lg border border-border/60 bg-card p-3 shadow-sm"
          >
            <div className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">
              {c.label}
            </div>
            <div className={`mt-1 font-display text-2xl font-semibold ${c.accent}`}>
              {loading ? "…" : `${value}${(c as { suffix?: string }).suffix ?? ""}`}
            </div>
          </div>
        );
      })}
    </div>
  );
}
